// extracted by mini-css-extract-plugin
module.exports = {"textView":"styles_textView__3_HHC","footer":"styles_footer__dNhCT"};